var AssessmentReportInfo = /** @class */ (function () {
    function AssessmentReportInfo() {
        this.type = null;
        this.reason = null;
        this.commentDto = null;
        this.isViolation = true;
        this.addProctoringImagesToReport = false;
    }
    return AssessmentReportInfo;
}());
export { AssessmentReportInfo };
//# sourceMappingURL=assessmentReportInfo.js.map